module.exports = __webpack_public_path__ + "img/icon-chrome.d60a042e.svg";